let config = {};

config.cognito = {
  userPoolId: import.meta.env.REACT_APP_COGNITO_USER_POOL_ID,
  clientId: import.meta.env.REACT_APP_COGNITO_CLIENT_ID
}

config.api = {
  userUrl: import.meta.env.REACT_APP_API_USER_URL,
  plaidUrl: import.meta.env.REACT_APP_API_PLAID_URL,
  plaidKey: import.meta.env.REACT_APP_API_PLAID_KEY,
}

config.environment = import.meta.env.REACT_APP_NODE_ENV;
config.app = {};

config.app.title = 'Xfred';
config.app.version = `1.0.${String(import.meta.env.REACT_APP_BUILD_NUMBER || '0').padStart(3, '0')}`;
config.app.enableUserCreation = import.meta.env.REACT_APP_ENABLE_USER_CREATION === 'true';

if (config.environment === 'local')
  config.app.title += ' Local';
else if (config.environment === 'sandbox')
  config.app.title += ' Sandbox';

config.app.year = new Date().getFullYear();

export default config;